import { render, staticRenderFns } from "./EditLanguagesDialog.vue?vue&type=template&id=c0be53d2&scoped=true&"
import script from "./EditLanguagesDialog.vue?vue&type=script&lang=js&"
export * from "./EditLanguagesDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditLanguagesDialog.vue?vue&type=style&index=0&id=c0be53d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0be53d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
